import { Gender } from '../../../generated/globalTypes';

export const genderType = [
  { label: t(['Laki-laki', 'MALE']), value: Gender.MALE },
  { label: t(['Perempuan', 'FEMALE']), value: Gender.FEMALE },
];
